import React, { Component } from 'react'
import { connect } from 'react-redux'
import MainHeaderNav from '../main-header-nav'

import moment from 'moment'

import {
	openModal,
	changeTitle,
	toggleCapacityInclusion
} from 'state/actions'

import SmoothCollapse from 'react-smooth-collapse'

import {
	getCurrentAccount,
	getCurrentUser,
	isCurrentUserAdmin,
	getUserRoles,
} from 'state/selectors'

import WeekNav from 'components/week-nav/week-nav'

import QuickTasks from './quick-tasks'
import Capacity from './capacity'
import TeamCalendar from './team-calendar'

import {
	Switch,
	Route,
	Redirect,
	withRouter
} from 'react-router'

class Planning extends Component {
	constructor(props) {
		super(props)
		this.state = {
			pageIndex: 0
		}
	}

	UNSAFE_componentWillMount() {
		const {
			changeTitle,
		} = this.props

		changeTitle('Planning')
	}

	changeDay = (type, canChange) => {
		if (!canChange) {
			return
		}

		const currentPageIndex = this.state.pageIndex
		let newPageIndex = null

		switch (type) {
			case 'prev':
				newPageIndex = currentPageIndex + 1
				break
			case 'next':
				newPageIndex = currentPageIndex - 1
				break
			case 'today':
				newPageIndex = 0
				break
		}

		this.setState({
			pageIndex: newPageIndex
		})
	}

	getCurrentDates = _ => {
		const {
			pageIndex,
		} = this.state

		const start = moment().startOf('week').subtract(pageIndex, 'week')
		const end = moment(start).add(1, 'week').subtract(1, 'day')

		return {
			start,
			end
		}
	}

	toggleTeamInclusion = team => {
		const { toggleCapacityInclusion, accountData } = this.props

		toggleCapacityInclusion(team, accountData)
	}

	render() {
		const {
			accountData,
			match,
			location,
			allTeams
		} = this.props

		const {
			pageIndex
		} = this.state

		if (!accountData) {
			return null
		}

		const accountTeams = (() => {
			const _teams = []

			Object.keys(allTeams || {}).forEach(teamId => {
				const team = allTeams[teamId]
		
				if (team.account_id === accountData.id) {
					_teams.push(team)
				}
			})

			return _teams
		})().sort((a,b) => a.order - b.order)

		const navtabs = [
			{
				name: 'Capacity',
				path: 'capacity',
				Component: Capacity
			},
			{
				name: 'Team Calendar',
				path: 'team-calendar',
				Component: TeamCalendar
			}
		]

		if(accountData && accountData.slug.includes('thinkerbell')){
			navtabs.unshift({
				name: 'Resourcing',
				path: 'resourcing',
				Component: QuickTasks
			})
		}

		const selectedDates = this.getCurrentDates()

		const isCapacity = location.pathname.includes('/planning/capacity')

		return (
			<div className="planning-section">
				<header className="main-header">
					<h1>
						Planning
					</h1>
					<div className="button-area" />
					<MainHeaderNav
						right={false}
						relUrl={match.url}
						navtabs={navtabs}
						type='routes'
					/>
				</header>
				<main>
					<SmoothCollapse 
						expanded={!!isCapacity}
						allowOverflowWhenOpen={true}
					>
						<WeekNav
							changeDay={this.changeDay}
							canChange={{
								back: true,
								forward: true
							}}
							pageIndex={pageIndex}
							paginateType={'week'}
							dates={selectedDates}
							buttons={[
								{
									size: 'big',
									level: 'low',
									label: `Visible teams`,
									icon: 'fe-user-plus',
									dropDown: {
										type: 'user',
										positionRight: true,
										items: accountTeams,
										selectedCheck: item => {
											return accountData.teams_included_in_capacity && ~accountData.teams_included_in_capacity.indexOf(item.id)
										},
										selectCallback: this.toggleTeamInclusion
									}
								}
							]}
						/>
					</SmoothCollapse>
					<Switch>
						{navtabs.map(({
							path,
							Component
						}) => (
							<Route path={`${match.url}/${path}`} key={path} render={routeProps => (
								<Component
									{...routeProps}
									selectedDates={selectedDates}
								/>
							)} />
						))}
						<Redirect to={match.path + '/' + navtabs[0].path} />
					</Switch>
				</main>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		accountData: getCurrentAccount(state),
        allTeams: state.account.entities.teams,
		userData: getCurrentUser(state),
		amAdmin: isCurrentUserAdmin(state),
		roles: getUserRoles(state),
	}
}

export default withRouter(connect(mapStateToProps, {
	openModal,
	changeTitle,
	toggleCapacityInclusion
})(Planning))